const AIRLINE_WEBSITES: Record<string, string> = {
  // Indian Low Cost Carriers
  "6E": "https://www.goindigo.in",           // IndiGo
  "SG": "https://www.spicejet.com",          // SpiceJet
  "QP": "https://www.akasaair.com",          // Akasa Air
  "IX": "https://www.airindiaexpress.com",  // Air India Express

  // Air India (optional - only if you DON'T want Lock Price)
  // "AI": "https://www.airindia.com",

  // International LCCs (if your portal supports international flights)
  "TR": "https://www.flyscoot.com",          // Scoot
  "FD": "https://www.airasia.com",           // Thai AirAsia
  "AK": "https://www.airasia.com",           // AirAsia Malaysia
  "QZ": "https://www.airasia.com",           // Indonesia AirAsia
  "Z2": "https://www.airasia.com",           // AirAsia Philippines
  "D7": "https://www.airasia.com",           // AirAsia X

  "G9": "https://www.airarabia.com",         // Air Arabia
  "FZ": "https://www.flydubai.com",          // flydubai
  "J9": "https://www.jazeeraairways.com",    // Jazeera Airways
  "PC": "https://www.flypgs.com",            // Pegasus Airlines
  "VJ": "https://www.vietjetair.com",        // VietJet Air
  "U2": "https://www.easyjet.com",           // easyJet
  "FR": "https://www.ryanair.com",           // Ryanair
  "W6": "https://wizzair.com",               // Wizz Air
  "NK": "https://www.spirit.com",            // Spirit Airlines
  "F9": "https://www.flyfrontier.com",       // Frontier Airlines
  "SY": "https://www.suncountry.com",        // Sun Country
  "OD": "https://www.batikair.com",          // Batik Air Malaysia (formerly Malindo)
};

export default AIRLINE_WEBSITES;